import firebase from "../firebase";
import DB_PATH from "../DB_PATH";

import { Plan } from "../../types/Plan";
import { setPlan } from "./setPlan";
import { uploadMedia } from "../media/cloudflareMedia";

export default async ({ plan }: { plan: Plan }) => {
  //@ts-ignore
  const { imagecoverImageURL } = plan;
  if (imagecoverImageURL) {
    const uploaded = await uploadMedia({
      body: imagecoverImageURL,
      kind: "image",
      fileName: imagecoverImageURL.name,
      firebasePath:
        `${DB_PATH.PLAN}/${plan.id}/${imagecoverImageURL.name}`,
      onProgress: (fraction) =>
        console.log(`Upload is ${Math.round(fraction * 100)}% done`),
    });
    plan = { ...plan, coverImageURL: uploaded.url };
    //@ts-ignore
    delete plan.imagecoverImageURL;
    await setPlan(plan);
  } else {
    await setPlan(plan);
  }
};
